import { mapActions, mapGetters } from 'vuex'
import validationMixin from '@/mixins/validation'

import contentForm from '../../components/content-form/index.vue'

export default {
  name: 'news-create',
  mixins: [validationMixin],
  data () {
    return {
      locale: '',
      id: this.$route.params.id
    }
  },
  components: {
    contentForm
  },
  computed: {
    ...mapGetters({
      content: 'newsContent/content',
      contentLoading: 'newsContent/contentLoading',
      accessCountries: 'profile/accessCountries',
      basicCountries: 'setting/basicCountries'
    }),
    newsStatuses () {
      return [
        {
          name: 'Draft',
          slug: 'draft',
          id: 1
        },
        {
          name: 'Test',
          slug: 'test',
          id: 2
        },
        {
          name: 'Actual',
          slug: 'actual',
          id: 4
        },
        {
          name: 'Deprecated',
          slug: 'deprecated',
          id: 5
        },
        {
          name: 'Wrong',
          slug: 'wrong',
          id: 6
        }
      ]
    },
    listLocales () {
      if (this.$route.name === 'news.categories') {
        return this.basicCountries
      }
      if (this.accessCountries && this.content) {
        const currentCountry = this.accessCountries.find(e => e.country_id === this.content.country)
        if (currentCountry) {
          return currentCountry.locales.data
        } else {
          return []
        }
      }
      return []
    }
  },
  created () {
    this.fetchBasicCountries()
    if (!this.content) {
      this.fetchContent({
        id: this.$route.params.id,
        module: this.$route.name
      }).then(response => {
        this.locale = response.default_locale
      })
    }
  },
  methods: {
    ...mapActions({
      fetchContent: 'newsContent/CONTENT_GET_DATA',
      fetchBasicCountries: 'setting/GET_BASIC_COUNTRIES'
    })
  }
}
